(function () {
  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function slugify(text) {
    return normalizeText(text)
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9а-яіїєґüöäß]+/gi, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getUniqueId(base, usedIds) {
    let id = base || 'section';
    let counter = 2;

    while (usedIds.has(id) || document.getElementById(id)) {
      id = `${base}-${counter}`;
      counter += 1;
    }

    usedIds.add(id);
    return id;
  }

  function isBadGeneratedHeading(text) {
    return /(@|phone|mail|email|karl-|aerofoils gmbh|managing director|^\d{5})/i.test(text);
  }

  function findGeneratedHeadings(content) {
    const candidates = [];

    content.querySelectorAll('p').forEach(function (element) {
      const text = normalizeText(element.textContent);

      if (!text || text.length > 140) return;
      if (isBadGeneratedHeading(text)) return;

      const strong = element.querySelector(':scope > strong, :scope > b');
      if (!strong) return;

      const strongText = normalizeText(strong.textContent);
      const isOnlyStrong = strongText === text;
      const looksLikeSection =
        /^(§|\d+\.|section\s+\d+|[A-ZÄÖÜ][^.!?]{2,100}$)/i.test(text);

      if (isOnlyStrong || looksLikeSection) {
        element.classList.add('policies-page__generated-heading');
        candidates.push(element);
      }
    });

    return candidates;
  }

  function getHeadings(content) {
    let headings = Array.from(content.querySelectorAll('h2'));

    if (headings.length < 2) {
      headings = Array.from(content.querySelectorAll('h2, h3'));
    }

    if (headings.length < 2) {
      headings = findGeneratedHeadings(content);
    }

    return headings.filter(function (heading) {
      return normalizeText(heading.textContent).length > 0;
    });
  }

  function scrollToElement(element) {
    if (!element) return;

    const header = document.querySelector('.site-header, header.site-header, header');
    const headerOffset = header ? header.offsetHeight : 0;
    const extraOffset = 24;

    const top =
      element.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset -
      extraOffset;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }

  function setActiveLink(root, targetId) {
    const links = root.querySelectorAll('[data-policies-nav-link], [data-policies-mobile-option]');

    links.forEach(function (link) {
      link.classList.toggle('is-active', link.dataset.targetId === targetId);
    });

    const activeMobile = root.querySelector(
      `[data-policies-mobile-option][data-target-id="${targetId}"]`
    );
    const label = root.querySelector('[data-policies-mobile-dropdown-label]');

    if (activeMobile && label) {
      label.textContent = normalizeText(activeMobile.textContent);
    }
  }

  function buildNavigation(root) {
    const sidebar = root.querySelector('[data-policies-sidebar]');
    const nav = root.querySelector('[data-policies-nav]');
    const mobileOptions = root.querySelector('[data-policies-mobile-options]');
    const mobileDropdown = root.querySelector('[data-policies-mobile-dropdown]');
    const content = root.querySelector('[data-policies-content]');

    if (content) {
  content.querySelectorAll('p').forEach((paragraph) => {
    const cleanedHtml = paragraph.innerHTML
      .replace(/&nbsp;/gi, '')
      .replace(/\u00a0/g, '')
      .replace(/<br\s*\/?>/gi, '')
      .trim();

    const cleanedText = paragraph.textContent
      .replace(/\u00a0/g, '')
      .trim();

    if (!cleanedHtml && !cleanedText) {
      paragraph.remove();
    }
  });
}

    if (!sidebar || !nav || !mobileOptions || !content) return;

    const headings = getHeadings(content);

    if (!headings.length) {
      sidebar.hidden = true;
      return;
    }

    sidebar.hidden = false;
    nav.innerHTML = '';
    mobileOptions.innerHTML = '';

    const usedIds = new Set();

    const allLabel =
      root.querySelector('[data-policies-mobile-dropdown-label]')?.textContent.trim() ||
      'All Sections';

    const allMobileOption = document.createElement('a');
    allMobileOption.href = '#';
    allMobileOption.className = 'policies-page__mobile-dropdown-option is-active';
    allMobileOption.textContent = allLabel;
    allMobileOption.dataset.policiesMobileOption = '';
    allMobileOption.dataset.targetId = root.id;

    mobileOptions.appendChild(allMobileOption);

    allMobileOption.addEventListener('click', function (event) {
      event.preventDefault();

      setActiveLink(root, root.id);

      if (mobileDropdown) {
        mobileDropdown.removeAttribute('open');
      }

      scrollToElement(root);
    });

    headings.forEach(function (heading, index) {
      const label = normalizeText(heading.textContent);
      const baseId = 'policy-' + slugify(label);
      const id = heading.id || getUniqueId(baseId, usedIds);

      heading.id = id;
      heading.classList.add('policies-page__heading-anchor');

      const navLink = document.createElement('a');
      navLink.href = `#${id}`;
      navLink.className = 'policies-page__nav-link' + (index === 0 ? ' is-active' : '');
      navLink.textContent = label;
      navLink.dataset.policiesNavLink = '';
      navLink.dataset.targetId = id;

      nav.appendChild(navLink);

      const mobileOption = document.createElement('a');
      mobileOption.href = `#${id}`;
      mobileOption.className =
        'policies-page__mobile-dropdown-option' + (index === 0 ? ' is-active' : '');
      mobileOption.textContent = label;
      mobileOption.dataset.policiesMobileOption = '';
      mobileOption.dataset.targetId = id;

      mobileOptions.appendChild(mobileOption);

      [navLink, mobileOption].forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();

          setActiveLink(root, id);

          if (mobileDropdown) {
            mobileDropdown.removeAttribute('open');
          }

          history.replaceState(null, '', `#${id}`);
          scrollToElement(heading);
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (
        mobileDropdown &&
        mobileDropdown.hasAttribute('open') &&
        !mobileDropdown.contains(event.target)
      ) {
        mobileDropdown.removeAttribute('open');
      }
    });

    const onScroll = function () {
      let activeId = headings[0].id;

      headings.forEach(function (heading) {
        const rect = heading.getBoundingClientRect();

        if (rect.top <= 160) {
          activeId = heading.id;
        }
      });

      setActiveLink(root, activeId);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (window.location.hash) {
      const target = content.querySelector(window.location.hash);

      if (target) {
        setTimeout(function () {
          scrollToElement(target);
          setActiveLink(root, target.id);
        }, 250);
      }
    }
  }

  function initPoliciesPages() {
    document.querySelectorAll('[data-policies-page]').forEach(function (root) {
      if (root.dataset.policiesReady === 'true') return;
      root.dataset.policiesReady = 'true';

      buildNavigation(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initPoliciesPages);
  document.addEventListener('shopify:section:load', initPoliciesPages);
})();
